import KanbanPage from "../../../components/kanban";
import MaintenanceTracking from "../../../components/maintenanceTracking";
import { NewUiGate } from "../../../features/newUi";

const MaintenanceMonitoring = (props: any) => {
    return (
        <NewUiGate
            legacy={<KanbanPage persona="MANAGER" {...props} />}
            next={<MaintenanceTracking persona="MANAGER" {...props} />}
        />
    );
};

export default MaintenanceMonitoring;
